import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import ArrowLeft from '../components/icons/ArrowLeft';
import ArrowRight from '../components/icons/ArrowRight';

import _ from "lodash";

const createArrowButton = (direction) => {
  return (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        className={className}
        style={style}
        onClick={onClick}
      >
        {direction === 'left' ? <ArrowLeft width={50} fill="white" /> : <ArrowRight width={50} fill="white" />}
      </button>
    );
  }
}

const NextButton = createArrowButton('right');
const PrevButton = createArrowButton('left');

export default class MySlider extends PureComponent {
  static propTypes = {
    type: PropTypes.string
  };
  static defaultProps = {
    type: ""
  };
  render() {
    const { sliderRef, items, uiRenderer, settings, type } = this.props;
    const options = {
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 2000,
      dots: false,
      infinite: true,
      arrows: true,
      nextArrow: <NextButton />,
      prevArrow: <PrevButton />,
      fade: true,
      pauseOnHover: false,
      ...settings
    };
    if (_.isEmpty(items)) return null;
    return (
      <Slider ref={sliderRef} {...options} className={type}>
        {_.map(items, (item, index) => (
          <div key={index}>{uiRenderer(item, index)}</div>
        ))}
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js